const highlightTool = {
	namespaced: true,
	state:      () => {
		return {
			selectedClips:                [],
			highlightIqSelectedClips:     [],
			currentClipIndex:             0,
			selectedAutoHighlightFormula: null,
		};
	},
	mutations: {
		updateSelectedClips(state, clips) {
			state.selectedClips = clips;
			if (state.currentClipIndex >= clips.length) {
				state.currentClipIndex = Math.max(0, clips.length - 1);
			}
		},
		updateHighlightIqSelectedClips(state, clips) {
			state.highlightIqSelectedClips = clips;
		},
		updateCurrentClipIndex(state, index) {
			state.currentClipIndex = index;
		},
		setSelectedAutoHighlightFormula(state, formula) {
			state.selectedAutoHighlightFormula = formula;
		},
	},
	getters: {
		selectedClips:            (state) => state.selectedClips,
		highlightIqSelectedClips: (state) => state.highlightIqSelectedClips,
		currentClipIndex:         (state) => state.currentClipIndex,
		currentClip:              (state) => {
			return state.selectedClips[state.currentClipIndex];
		},
		selectedAutoHighlightFormula: (state) => state.selectedAutoHighlightFormula,
	},
	actions: {
		updateSelectedClips({ commit }, clips) {
			commit('updateSelectedClips', clips);
		},
		updateHighlightIqSelectedClips({ commit }, clips) {
			commit('updateHighlightIqSelectedClips', clips);
		},
		nextClip({ commit, state }) {
			if (state.currentClipIndex < state.selectedClips.length - 1) {
				commit('updateCurrentClipIndex', state.currentClipIndex + 1);
			}
		},
		prevClip({ commit, state }) {
			if (state.currentClipIndex > 0) {
				commit('updateCurrentClipIndex', state.currentClipIndex - 1);
			}
		},
		goToClip({ commit, state }, clip) {
			const index = state.selectedClips.findIndex((c) => c.id === clip.id);
			commit('updateCurrentClipIndex', index);
		},
		setSelectedAutoHighlightFormula({ commit }, formula) {
			commit('setSelectedAutoHighlightFormula', formula);
		},
	},
};

export default highlightTool;
